import React from "react";

import "./Clients.css";

const clients = () => {
  return (
    <section id="clients-architecture" className="py-3">
      <div className="container p-5">
        <div className="row">
          <div className="col">
            <h1>Klienci</h1>
            <ul>
              <li className="orange-color mb-2">
                ponad 300 realizacji indywidualnych
              </li>{" "}
              <li>1997 r. Kielce - Kolporter Sp. z o.o. </li>
              <li>1998 r. Brzesko - P.H.U. MARK</li>
              <li>2000 r. Tarnów - Restauracja Tatrzańska</li>
              <li>2001 r. Brzesko - Firma P.B.H.T Edmund Leś</li>
              <li>2001 r. Tarnów, Kraków - Ampli S.A.</li>
              <li>
                2002 r. Dąbrowa Tarnowska - Jan Pabian blacharstwo i
                lakiernictwo samochodowe
              </li>
              <li>2002 r. Tarnów - PZU</li>
              <li>2002 r. Dąbrowa Tarnowska - Unident</li>
              <li>2002 r. Tarnów - Restauracja Grubcio</li>
              <li>2004 r. Łęg Tarnowski - Auto- Biedroń</li>
              <li>2005 r. Tarnów - Cukiernia Jan Kudelski</li>
              <li>2005 r. Tarnów - Campari Bistro – Café</li>
              <li>2006 r. Tarnów - Klub Wall Street Bull</li>
              <li>2006 r. Bochnia - Sad Rejonowy w Bochni</li>
              <li>2006 r. Brzesko - Cukiernia W. Kudelski</li>
              <li>2008 r. Tarnów - Sad Okręgowy w Tarnowie</li>
              <li>2008 r. Tarnobrzeg - Sad Okręgowy w Tarnobrzegu</li>
              <li>2008 r. Kraków - PKP Rejon Dworców w Krakowie</li>
              <li>2008 r. Rzeszów - PKP Rzeszów</li>
              <li>2010 r. Tarnów - Bank BGK w Tarnowie</li>
              <li>2010 r. Brzesko - Sad Rejonowy w Brzesku</li>
              <li>2011 r. Tarnów - Restauracja i Pizzeria Młyn</li>
              <li>2012 r. Tarnów - Bar Frasses</li>
              <li>2012 r. Zbylitowska Góra - Hotel Kardamon</li>
              <li>2012 r. Łęg Tarnowski - Samson Sp. z o.o.</li>
              <li>2012 r. Tarnów - P.H.U Elektro-system . Marian Babiarz</li>
              <li>2012 r. Tarnów - MWSE</li>
              <li>
                2015 r. Dąbrowa Tarnowska - Sad Rejonowy w Dąbrowie Tarnowskiej
              </li>
              <li>2016 r. Radom - Sad Okręgowy w Radomiu</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default clients;



// WEBPACK FOOTER //
// ./src/components/Architecture/Clients/Clients.js